/* eslint-disable */

import React from 'react';
import FormSearch from "./FormSearch";
import ListDeliveryNoteEmployee from "./ListDeliveryNote";
import {Layout} from "antd";
const {Content} = Layout;

class DeliveryNoteEmployee extends React.PureComponent{
    render() {
        return(
            <Content className="a-content a-content--page-list">
                <FormSearch/>
                <ListDeliveryNoteEmployee/>
            </Content>
        )
    }
}
export default DeliveryNoteEmployee;